var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Index',{attrs:{"img":(_vm.img),"buttonText":(_vm.buttonText)}}),_c('mpx-view',{on:{"tap":_vm.clickHandle}},[_vm._v("dian我")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }